import { components } from 'shared/data/walletsKyc/v1';

export const initialEstimatedMonthlyTransactionCurrency = 'GBP';

export const buildAccountUsageTwoInitialValues = (
    accountUsage: components['schemas']['FormAccountUsageAnswer'] | undefined
) => ({
    estimatedMonthlyTransactionVolume: accountUsage?.estimatedMonthlyTransactionVolume?.toString(),
    estimatedMonthlyTransactionValue: accountUsage?.estimatedMonthlyTransactionValue?.toString(),
    estimatedMonthlyTransactionCurrency:
        accountUsage?.estimatedMonthlyTransactionCurrency ?? initialEstimatedMonthlyTransactionCurrency,
});

export const estimatedMonthlyTransactionVolumes = <const>['1', '20', '50', '100', '150'];
export const estimatedMonthlyTransactionValues = <const>['10000', '50000', '100000', '500000', '600000'];
